export default __webpack_public_path__ + "static/media/6. purchase-orders.6f874c91.png";